import axios from 'axios';
import {
	SELLER_INDEX,
	ESTIMATION_UPDATE_STEP, 
	ESTIMATION_COMPUTE_SUCCESS, ESTIMATION_COMPUTE_ERROR,
	VALORISATION_CLICK_NEXT, VALORISATION_CLICK_PROGRESS_BAR, 
} from './types';

import { API } from '../config';
import { change } from 'redux-form';
import i18n from "i18next";
import _ from 'lodash';
const BEARER = "Bearer";

// Estimation 
export function estimation_update_step(id){
	return ({
		type: ESTIMATION_UPDATE_STEP,
		payload: id
	});
}

export function estimationCompute(datasform, emailform){
	// Read lng from URL param (?lng=fr), fallback to i18n
	const urlParams = new URLSearchParams(window.location.search);
	const lng = urlParams.get('lng') || i18n.language;

	// Detect origin domain from parent window (iframe)
	let origin = '';
	try {
		origin = window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0
			? new URL(window.location.ancestorOrigins[0]).hostname
			: document.referrer
				? new URL(document.referrer).hostname
				: window.location.hostname;
	} catch(e) {
		origin = window.location.hostname;
	}

	return function(dispatch) {
		axios(`${API}/estimation/computeAndSend/`, {
			method:'post',
			headers: {'Content-Type' : 'application/json'},
			data:{
				form: datasform,
				emailform:emailform,
				lng: lng,
				origin: origin
			}
		})
		.then(response => {
			dispatch({ 
				type: ESTIMATION_COMPUTE_SUCCESS,
				payload: response.data.enterpriseValue,
			});
		})
		.catch(err => {
			dispatch({ 
				type: ESTIMATION_COMPUTE_ERROR,
				payload: null,
			});
		})
	}
}

// Valorisation

export function valorisationClickNext(page){
	const current = Math.min(page.pageCurrent+1, page.pageFinal); 
	return ({
		type: VALORISATION_CLICK_NEXT,
		payload: {
			current: current,
			max: Math.min(current,page.pageFinal) 
		}	
	});
}

export function valorisationClickPrevious(page){
	const current = Math.max(page.pageCurrent-1, 1); 
	return ({
		type: VALORISATION_CLICK_NEXT,
		payload: {
			current: current,
			max: Math.min(current,page.pageFinal) 
		}	
	});
}

export function valorisationClickProgressBar(id){
	return ({
		type: VALORISATION_CLICK_PROGRESS_BAR,
		payload: id
	});
}

export function setSellerIndex(index){
	return ({
		type: SELLER_INDEX,
		payload: index
	});
}

// Submit Data

export function submitFormEstimationInitialize(){
	return change('formEstimation', 'ownerRealEstate', false);
}
